// Button primitive (Phase 0, design-system audit §7). Wraps the existing .btn classes
// so callers stop hand-writing class strings and every button gets the same focus ring,
// disabled, and loading behaviour. Does NOT change the visual look of .btn.
import { forwardRef } from "react";

const VARIANT = {
  primary: "btn",
  ghost: "btn btn--ghost",
  danger: "btn btn--ghost btn--danger",   // transparent bg + neg text/border (the intended danger look)
};

export const Button = forwardRef(function Button(
  { variant = "primary", size, loading = false, disabled = false, className = "", children, ...rest },
  ref
) {
  const cls = [VARIANT[variant] || VARIANT.primary, size === "sm" ? "btn--xs" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      ref={ref}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? "…" : children}
    </button>
  );
});
